import { SafeFonts } from '@/types/theme-packs.types';

const EmailWrapper = (html: string, backgroundColor = '#FFFFFF', fonts?: SafeFonts) => {
  return `
		<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
		<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
		<head>
			<!--[if gte mso 9]><xml>
			<o:OfficeDocumentSettings>
			<o:AllowPNG/>
			<o:PixelsPerInch>96</o:PixelsPerInch>
			</o:OfficeDocumentSettings>
			</xml><![endif]-->
			<title>BrandLive</title>
			<meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
			<meta http-equiv="X-UA-Compatible" content="IE=edge" />
			<meta name="viewport" content="width=device-width, initial-scale=1.0 " />
			<meta name="format-detection" content="telephone=no"/>
			<!--[if !mso]><!-->
			<style>
			@import url('https://assets.brandlive.com/assets/fonts/replacement/familyInterwght100200300400500600700800900displayswap.css');
			@import url('https://assets.brandlive.com/assets/fonts/replacement/familyRobotoitalwght010003000400050007000900110013001400150017001900displayswap.css');
			</style>
			<!--<![endif]-->
			<style type="text/css">
				body { margin: 0; padding: 0; -webkit-text-size-adjust: 100% !important; -ms-text-size-adjust: 100% !important; -webkit-font-smoothing: antialiased !important; }
				img { border: 0 !important; outline: none !important; }
				h1, h2, h3, h4, h5, p { margin: 0px; padding: 0px;}
				h1, h2, h3, h4, h5 { font-family: '${fonts ?? SafeFonts.Arial}'}
				p { font-family: '${fonts ?? SafeFonts.Arial}'}
				table { border-collapse: collapse; mso-table-lspace: 0px; mso-table-rspace: 0px; }
				td, a, span { border-collapse: collapse; mso-line-height-rule: exactly; }
				.ExternalClass { width: 100%; }
				.ExternalClass * { line-height: 100%; }
				.ReadMsgBody { width: 100%; }
				#outlook a { padding: 0; }
				.im { color: inherit !important; }
				.ii a[href] { color: -webkit-link; }
			</style>
		</head>
		<body class="em_body" style="margin:0px auto; padding:0px; background:${backgroundColor};">
			${html}
		</body>
		</html>
	`;
};

export default EmailWrapper;

// ^^ ".im" is a class that gmail adds that changes the color of content if there are multiple emails in the same thread (i.e., same sender/subject)
// ^^ ".ii a[href]" is a class that gmail adds that changes the color of anchor tags

// removed this code from the styles above, but keeping it around because it's a good reference on how to add gmail msg classes
// a[x-apple-data-detectors], u + .em_body a, #MessageViewBody a { color: inherit; text-decoration: none; font-size: inherit !important; font-family: inherit !important; font-weight: inherit !important; line-height: inherit; }
